import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { USUARIOS_NUEVO, USUARIOS_LISTA, USUARIOS_FIRMAS, USUARIOS_SEDES_SERIES } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoPage from './nuevo'
import FirmasPage from './firmas'
import ReporteSeriesPage from './reporte-series'

export default function UsuariosPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${USUARIOS_NUEVO}/:id`} component={NuevoPage} />
        <Route path={`/${USUARIOS_FIRMAS}/:id`} component={FirmasPage} />
        <Route path={`/${USUARIOS_NUEVO}`} component={NuevoPage} />
        <Route path={`/${USUARIOS_LISTA}`} component={ListaPage} />
        <Route path={`/${USUARIOS_SEDES_SERIES}`} component={ReporteSeriesPage} />
      </Switch>
    </Suspense>
  )
}
